import { Button } from '@mui/material';
import React from 'react';
import illu from '../../../../Assets/videos/parrainage.gif'
const Sponsor = () => {
    return (
        <div className='h-full px-4 mx-auto lg:w-[95%] md:px-8'>
            <div>
                <h2 className='font-extrabold text-first lg:text-[34px] uppercase text-lg lg:leading-10'>Voyez encore plus loin, parrainer vos proches et cumuler les avantages.</h2>
                <p className='font-extrabold lg:text-[26px] text-first md:py-10 text-base lg:py-8 lg:leading-[40.92px]'>
                    À chaque cours effectué par vos filleuls, vous obtenez 20% H.T de la commission Teach’r pendant une certaine durée.
                </p>
            </div>
            <div className="flex flex-col items-center justify-between lg:gap-x-14 gap-x-8 md:flex-row">
                <div className='w-full h-[calc(100vh_-_21.5rem)]  bg-center bg-no-repeat bg-contain' style={{ backgroundImage: `url(${illu})` }}>
                </div>
                <div className='lg:pt-8 text-first md:pt-0'>
                    <h3 className='font-extrabold lg:text-2xl text-first'>Pendant combien de temps vais-je percevoir ces commissions ?</h3>
                    <div className='font-bold lg:text-[22px] pt-8 pb-14 flex flex-col md:gap-y-10 gap-y-4'>
                        <p>Si vous parrainez entre 1 et 4 filleuls, vous bénéficierez de cette commission pendant 12 mois.</p>
                        <p>Entre 5 et 9 filleuls, vous bénéficierez de cette commission pendant 24 mois.</p>
                        <p>Entre 10 et 14 filleuls, vous bénéficierez de cette commission pendant 36 mois.</p>
                    </div>
                    <Button className='w-full py-2 font-extrabold text-white rounded-full bg-first lg:text-2xl'>En savoir plus</Button>
                </div>
            </div>
        </div>
    );
};

export default Sponsor;